import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ReportsOrderRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.reports_create === true ||
    permissions.reports_edit === true ||
    permissions.reports_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default ReportsOrderRouteMiddleware;
